import React from 'react';
import { Translate, useTranslate } from 'core/translate';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { getLocateADealerUrl } from '../../resources/shoppingLinks/shoppingHelper.constant';

const PaymentEstimatorTabs = ({ defaultTabIndex, onClose, urls, params }) => {
  const translate = useTranslate();
  const { locateDealerUrl: locateDealerTemplateUrl } = urls;
  const locateDealerUrl = getLocateADealerUrl(locateDealerTemplateUrl, params);

  return (
    <Tabs
      defaultIndex={defaultTabIndex}
      className="byo-tabs"
      selectedTabClassName="byo-tabs__tab--active">
      <TabList className="byo-tabs__tablist">
        <Tab className="byo-tabs__tab">
          <div className="byo-tabs__tab-label">
            <Translate value="component.pricing.finance.header" />
          </div>
        </Tab>
        <Tab className="byo-tabs__tab">
          <div className="byo-tabs__tab-label">
            <Translate value="component.pricing.lease.header" />
          </div>
        </Tab>
      </TabList>
      <TabPanel>
        <div className="pe-financebox__wrapper">
          <gmst-pe-financebox />
          <button
            className="button button--primary stat-button-link"
            data-dtm={translate('component.pricing.finance.header')}
            onClick={onClose}>
            <Translate value="select" />
          </button>
        </div>
      </TabPanel>
      <TabPanel>
        <div className="pe-leasebox__wrapper">
          <gmst-pe-leasebox>
            <span slot="localDealer">
              <a
                href={locateDealerUrl}
                className="pe-leasebox__link stat-button-link"
                data-dtm="lease">
                <gm-translate>leasebox.localDealer</gm-translate>
              </a>{' '}
            </span>
          </gmst-pe-leasebox>
          <button
            className="button button--primary stat-button-link"
            data-dtm={`${translate('component.pricing.payments.header')}:lease`}
            onClick={onClose}>
            <Translate value="select" />
          </button>
        </div>
      </TabPanel>
    </Tabs>
  );
};

export default PaymentEstimatorTabs;
